import { ACTIONS } from "./constants";
import {
  handleSetAction,
  handleSetConfigAction,
  handleSetErrorsAction,
  handleSetErrorAction,
  handleSetAsyncErrorAction,
  handleClearAsyncErrorAction,
  handleSetEditModeAction,
  handleSetValidationsAction,
  handleMergeAction,
  handleUpdateAnswerAction,
  handlePreviousSectionAction,
  handleNextSectionAction,
  handleValidateFormAction,
  handleRemoveErrorAction,
  handleSetAddressModeAction,
  handleShowQuestionAction,
  handleEditQuestionAction,
  handleAppendQuestionsAction,
  handleConfirmAssumptionGroupAction,
  handleSetCurrentSectionAction,
  handleSetVisibleAction,
  handleSetHiddenAction,
} from "./actions";
import type { QuestionnaireAction, QuestionnaireState } from "../types";

export { ACTIONS };

export const questionnaireReducer = (
  state: QuestionnaireState,
  action: QuestionnaireAction,
): QuestionnaireState => {
  const { type } = action;

  switch (type) {
    case ACTIONS.SET: {
      return handleSetAction(state, action.payload);
    }

    case ACTIONS.SET_CONFIG: {
      return handleSetConfigAction(state, action.payload);
    }

    case ACTIONS.SET_ERRORS: {
      return handleSetErrorsAction(state, action.payload);
    }

    case ACTIONS.SET_ERROR: {
      return handleSetErrorAction(state, action.payload);
    }

    case ACTIONS.SET_ASYNC_ERROR: {
      return handleSetAsyncErrorAction(state, action.payload);
    }

    case ACTIONS.CLEAR_ASYNC_ERROR: {
      return handleClearAsyncErrorAction(state, action.payload);
    }

    case ACTIONS.SET_EDIT_MODE: {
      return handleSetEditModeAction(state, action.payload);
    }

    case ACTIONS.SET_VALIDATIONS: {
      return handleSetValidationsAction(state, action.payload);
    }

    case ACTIONS.MERGE: {
      return handleMergeAction(state, action.payload);
    }

    case ACTIONS.UPDATE_ANSWER: {
      return handleUpdateAnswerAction(state, action.payload);
    }

    case ACTIONS.PREVIOUS_SECTION: {
      return handlePreviousSectionAction(state);
    }

    case ACTIONS.NEXT_SECTION: {
      return handleNextSectionAction(state);
    }

    case ACTIONS.VALIDATE_FORM: {
      return handleValidateFormAction(state);
    }

    case ACTIONS.REMOVE_ERROR: {
      return handleRemoveErrorAction(state, action.payload);
    }

    case ACTIONS.SET_ADDRESS_MODE: {
      return handleSetAddressModeAction(state, action.payload);
    }

    case ACTIONS.SHOW_QUESTION: {
      return handleShowQuestionAction(state, action.payload);
    }

    case ACTIONS.EDIT_QUESTION: {
      return handleEditQuestionAction(state, action.payload);
    }

    case ACTIONS.APPEND_QUESTIONS: {
      return handleAppendQuestionsAction(state, action.payload);
    }

    case ACTIONS.CONFIRM_ASSUMPTION_GROUP: {
      return handleConfirmAssumptionGroupAction(state, action.payload);
    }

    case ACTIONS.SET_CURRENT_SECTION: {
      return handleSetCurrentSectionAction(state, action.payload);
    }

    case ACTIONS.SET_VISIBLE: {
      return handleSetVisibleAction(state, action.payload);
    }

    case ACTIONS.SET_HIDDEN: {
      return handleSetHiddenAction(state, action.payload);
    }

    case ACTIONS.HYDRATE: {
      return action.payload;
    }

    default: {
      return state;
    }
  }
};
